import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { UserService } from '../../core/services';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/user.service";
import * as i2 from "@angular/common/http";
var AuthService = /** @class */ (function () {
    function AuthService(userService, http) {
        this.userService = userService;
        this.http = http;
        this.ACCESS_TOKEN_KEY = 'ml_access_token';
        this.REFRESH_TOKEN_KEY = 'ml_refresh_token';
    }
    Object.defineProperty(AuthService.prototype, "hasTokens", {
        get: function () {
            return (!!localStorage.getItem(this.ACCESS_TOKEN_KEY) &&
                !!localStorage.getItem(this.REFRESH_TOKEN_KEY));
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (loginCredentials) {
        var _this = this;
        return this.http.post('login', loginCredentials).pipe(tap(function (token) {
            _this.saveCredentials(token);
        }));
    };
    AuthService.prototype.logout = function () {
        this.clearCredentials();
        this.userService.removeCurrentUser();
    };
    AuthService.prototype.refreshToken = function () {
        var _this = this;
        var refreshToken = localStorage.getItem(this.REFRESH_TOKEN_KEY);
        return this.http
            .post('refresh-token', {
            refresh: refreshToken
        })
            .pipe(tap(function (token) {
            localStorage.setItem(_this.ACCESS_TOKEN_KEY, token.access);
        }));
    };
    AuthService.prototype.saveCredentials = function (token) {
        localStorage.setItem(this.ACCESS_TOKEN_KEY, token.access);
        localStorage.setItem(this.REFRESH_TOKEN_KEY, token.refresh);
    };
    AuthService.prototype.clearCredentials = function () {
        localStorage.removeItem(this.ACCESS_TOKEN_KEY);
        localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    };
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.HttpClient)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
